<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import ArrowDown from '../../../../assets/svg/ico-arrow-down.svg';
    import ArrowLeft from '../../../../assets/svg/ico-arrow-left.svg';
    import ArrowLongLeft from '../../../../assets/svg/ico-arrow-long-left.svg';
    import ArrowLongRight from '../../../../assets/svg/ico-arrow-long-right.svg';
    import ArrowRight from '../../../../assets/svg/ico-arrow-right.svg';
    import ArrowUp from '../../../../assets/svg/ico-arrow-up.svg';
    import Bookmark from '../../../../assets/svg/ico-bookmark.svg';
    import Check from '../../../../assets/svg/ico-check.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import Download from '../../../../assets/svg/ico-download.svg';
    import Envelope from '../../../../assets/svg/ico-envelope.svg';
    import Eye from '../../../../assets/svg/ico-eye.svg';
    import Facebook from '../../../../assets/svg/ico-facebook.svg';
    import Feather from '../../../../assets/svg/ico-feather.svg';
    import Frame from '../../../../assets/svg/ico-frame.svg';
    import HandPaper from '../../../../assets/svg/ico-hand-paper.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import Instagram from '../../../../assets/svg/ico-instagram.svg';
    import LineBottom from '../../../../assets/svg/ico-line-bottom.svg';
    import LineTop from '../../../../assets/svg/ico-line-top.svg';
    import LinkedinIn from '../../../../assets/svg/ico-linkedin-in.svg';
    import LocationArrowFill from '../../../../assets/svg/ico-location-arrow-fill.svg';
    import LocationArrow from '../../../../assets/svg/ico-location-arrow.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import MapMarkerAlt from '../../../../assets/svg/ico-map-marker-alt.svg';
    import Phone from '../../../../assets/svg/ico-phone.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import Question from '../../../../assets/svg/ico-question.svg';
    import SearchPlus from '../../../../assets/svg/ico-search-plus.svg';
    import Search from '../../../../assets/svg/ico-search.svg';
    import SignOut from '../../../../assets/svg/ico-sign-out.svg';
    import SlidersH from '../../../../assets/svg/ico-sliders-h.svg';
    import ThumbsUp from '../../../../assets/svg/ico-thumbs-up.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import User from '../../../../assets/svg/ico-user.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            ArrowDown,
            ArrowLeft,
            ArrowLongLeft,
            ArrowLongRight,
            ArrowRight,
            ArrowUp,
            Bookmark,
            Check,
            Dog,
            Download,
            Envelope,
            Eye,
            Facebook,
            Feather,
            Frame,
            HandPaper,
            Happy,
            Instagram,
            LineBottom,
            LineTop,
            LinkedinIn,
            LocationArrowFill,
            LocationArrow,
            Lock,
            MapMarkerAlt,
            Phone,
            PlusCircle,
            Question,
            SearchPlus,
            Search,
            SignOut,
            SlidersH,
            ThumbsUp,
            Twitter,
            User,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
